const {
  FETCH_WALLET,
  FETCH_TRANSACTIONS,
  FETCH_PAYMENT_TRANSACTION,
  INITIATE_STK_PUSH,
  WITHDRAW,
  FETCH_EXCHANGE_RATE,
  TRANSFERS,
  INITIATE_CARD_PAYMENT,
  INITIATE_BANK_TRANSFER,
  INITIATE_MERCHANT_PAYMENT,
  INITIATE_CASHIA_WITHDRAWAL,
} = require("_constants");
const {
  getSuccessActionType,
  getErrorActionType,
  getClearActionType,
} = require("_helpers");

const initialState = {
  wallet: null,
  walletStatus: null,

  transactions: null,
  transactionsStatus: null,

  initiateStkPushStatus: null,
  initiateStkPushData: null,

  paymentTransaction: null,
  paymentTransactionStatus: null,

  withdrawStatus: null,

  exchangeRateStatus: null,
  exchangeRate: null,

  transfersStatus: null,

  initiateCardPaymentStatus: null,
  initiateCardPaymentDetails: null,

  initiateBankTransferStatus: null,

  initiateMerchantPaymentStatus: null,

  initiateCashiaWithdrawalStatus: null,
};

const paymentReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_WALLET:
      return {
        ...state,
        walletStatus: "loading",
      };
    case getSuccessActionType(FETCH_WALLET):
      return {
        ...state,
        walletStatus: "success",
        wallet: action.payload,
      };
    case getErrorActionType(FETCH_WALLET):
      return {
        ...state,
        walletStatus: "error",
      };
    case getClearActionType(FETCH_WALLET):
      return {
        ...state,
        walletStatus: null,
      };
    case FETCH_TRANSACTIONS:
      return {
        ...state,
        transactionsStatus: "loading",
      };
    case getSuccessActionType(FETCH_TRANSACTIONS):
      return {
        ...state,
        transactionsStatus: "success",
        transactions: action.payload,
      };
    case getErrorActionType(FETCH_TRANSACTIONS):
      return {
        ...state,
        transactionsStatus: "error",
      };
    case getClearActionType(FETCH_TRANSACTIONS):
      return {
        ...state,
        transactionsStatus: null,
      };
    case INITIATE_STK_PUSH:
      return {
        ...state,
        initiateStkPushStatus: "loading",
        initiateStkPushData: null,
      };
    case getSuccessActionType(INITIATE_STK_PUSH):
      return {
        ...state,
        initiateStkPushStatus: "success",
        initiateStkPushData: action.payload,
      };
    case getErrorActionType(INITIATE_STK_PUSH):
      return {
        ...state,
        initiateStkPushStatus: "error",
        initiateStkPushData: null,
      };
    case getClearActionType(INITIATE_STK_PUSH):
      return {
        ...state,
        initiateStkPushStatus: null,
        initiateStkPushData: null,
      };
    case FETCH_PAYMENT_TRANSACTION:
      return {
        ...state,
        paymentTransactionStatus: "loading",
      };
    case getSuccessActionType(FETCH_PAYMENT_TRANSACTION):
      return {
        ...state,
        paymentTransactionStatus: "success",
        paymentTransaction: action.payload,
      };
    case getErrorActionType(FETCH_PAYMENT_TRANSACTION):
      return {
        ...state,
        paymentTransactionStatus: "error",
      };
    case getClearActionType(FETCH_PAYMENT_TRANSACTION):
      return {
        ...state,
        paymentTransactionStatus: null,
        paymentTransaction: null,
      };
    case WITHDRAW:
      return {
        ...state,
        withdrawStatus: "loading",
      };
    case getSuccessActionType(WITHDRAW):
      return {
        ...state,
        withdrawStatus: "success",
      };
    case getErrorActionType(WITHDRAW):
      return {
        ...state,
        withdrawStatus: "error",
      };
    case getClearActionType(WITHDRAW):
      return {
        ...state,
        withdrawStatus: null,
      };
    case FETCH_EXCHANGE_RATE:
      return {
        ...state,
        exchangeRateStatus: "loading",
      };
    case getSuccessActionType(FETCH_EXCHANGE_RATE):
      return {
        ...state,
        exchangeRateStatus: "success",
        exchangeRate: action.payload,
      };
    case getErrorActionType(FETCH_EXCHANGE_RATE):
      return {
        ...state,
        exchangeRateStatus: "error",
      };
    case getClearActionType(FETCH_EXCHANGE_RATE):
      return {
        ...state,
        exchangeRateStatus: null,
      };

    case TRANSFERS:
      return {
        ...state,
        transfersStatus: "loading",
      };
    case getSuccessActionType(TRANSFERS):
      return {
        ...state,
        transfersStatus: "success",
      };
    case getErrorActionType(TRANSFERS):
      return {
        ...state,
        transfersStatus: "error",
      };
    case getClearActionType(TRANSFERS):
      return {
        ...state,
        transfersStatus: null,
      };

    case INITIATE_CARD_PAYMENT:
      return {
        ...state,
        initiateCardPaymentStatus: "loading",
      };
    case getSuccessActionType(INITIATE_CARD_PAYMENT):
      return {
        ...state,
        initiateCardPaymentStatus: "success",
        initiateCardPaymentDetails: action.payload,
      };
    case getErrorActionType(INITIATE_CARD_PAYMENT):
      return {
        ...state,
        initiateCardPaymentStatus: "error",
      };
    case getClearActionType(INITIATE_CARD_PAYMENT):
      return {
        ...state,
        initiateCardPaymentStatus: null,
        initiateCardPaymentDetails: null,
      };

    case INITIATE_BANK_TRANSFER:
      return {
        ...state,
        initiateBankTransferStatus: "loading",
      };
    case getSuccessActionType(INITIATE_BANK_TRANSFER):
      return {
        ...state,
        initiateBankTransferStatus: "success",
      };
    case getErrorActionType(INITIATE_BANK_TRANSFER):
      return {
        ...state,
        initiateBankTransferStatus: "error",
      };
    case getClearActionType(INITIATE_BANK_TRANSFER):
      return {
        ...state,
        initiateBankTransferStatus: null,
      };

    case INITIATE_MERCHANT_PAYMENT:
      return {
        ...state,
        initiateMerchantPaymentStatus: "loading",
      };
    case getSuccessActionType(INITIATE_MERCHANT_PAYMENT):
      return {
        ...state,
        initiateMerchantPaymentStatus: "success",
      };
    case getErrorActionType(INITIATE_MERCHANT_PAYMENT):
      return {
        ...state,
        initiateMerchantPaymentStatus: "error",
      };
    case getClearActionType(INITIATE_MERCHANT_PAYMENT):
      return {
        ...state,
        initiateMerchantPaymentStatus: null,
      };

    case INITIATE_CASHIA_WITHDRAWAL:
      return {
        ...state,
        initiateCashiaWithdrawalStatus: "loading",
      };
    case getSuccessActionType(INITIATE_CASHIA_WITHDRAWAL):
      return {
        ...state,
        initiateCashiaWithdrawalStatus: "success",
      };
    case getErrorActionType(INITIATE_CASHIA_WITHDRAWAL):
      return {
        ...state,
        initiateCashiaWithdrawalStatus: "error",
      };
    case getClearActionType(INITIATE_CASHIA_WITHDRAWAL):
      return {
        ...state,
        initiateCashiaWithdrawalStatus: null,
      };
    default:
      return state;
  }
};

export default paymentReducer;
